.root {
  width: 100%;
  max-width: 80% !important;
}

.transcript {
  display: flex;
  width: 100%;
  height: 100%;
  max-height: 90%;
  overflow-y: scroll;
}

.timings {
  flex-grow: 0;
  flex-shrink: 0;
  width: 110px;
  padding-right: 10px;

  span {
    display: block;
    width: 100px;
    text-align: center;

    &:nth-child(odd) {
      background-color: var(--background);
    }
  }
}
